define("shared/components/shared/upgrade/all-features-modal", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _tracking, _emberConcurrency, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal
    @close={{@close}}
    @focusTrap={{@focusTrap}}
    data-test-id="modal"
    {{did-insert this.trackAllFeaturesShown}}
    as |modal|
  >
    <modal.card @portrait={{true}}>
      <modal.card-body class="tCH--plan--{{this.planType}}">
        <h1 class="tCH--title--h1 qa--checkout__allFeatureTitle">
          {{t "plans.append_plan" plan=this.planName}}
        </h1>
        {{#if this.isLoading}}
          <Shared::LoadingSpinner />
        {{else}}
          {{#each this.groups as |group|}}
            <ul class="tCH--featureList qa--plan__featureGroup--{{css-safe (camelize (lowercase group.title))}}">
              <li class="tCH--featureList__li">
                <div class="tCH--featureList__text">{{group.title}}</div>
              </li>
              {{#each group.features as |feature|}}
                {{! @glint-expect-error Shared::Upgrade::Feature not typed}}
                <Shared::Upgrade::Feature
                  @forCheckout="true"
                  @title={{feature.name}}
                  @type={{feature.type}}
                  @value={{feature.value}}
                />
              {{/each}}
            </ul>
          {{/each}}
        {{/if}}
      </modal.card-body>
  
      <modal.card-footer>
        <Shared::Ui::Button @additional="block" @onClick={{@close}} @text={{t "shared_words.close"}} @variant="outline" />
  
      </modal.card-footer>
  
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "GJqswvX8",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"modal\"],[4,[38,1],[[30,0,[\"trackAllFeaturesShown\"]]],null]],[[\"@close\",\"@focusTrap\"],[[30,1],[30,2]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,3,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"card-body\"]],[[16,0,[29,[\"tCH--plan--\",[30,0,[\"planType\"]]]]]],null,[[\"default\"],[[[[1,\"\\n      \"],[10,\"h1\"],[14,0,\"tCH--title--h1 qa--checkout__allFeatureTitle\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"plans.append_plan\"],[[\"plan\"],[[30,0,[\"planName\"]]]]]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"isLoading\"]],[[[1,\"        \"],[8,[39,4],null,null,null],[1,\"\\n\"]],[]],[[[42,[28,[37,6],[[28,[37,6],[[30,0,[\"groups\"]]],null]],null],null,[[[1,\"          \"],[10,\"ul\"],[15,0,[29,[\"tCH--featureList qa--plan__featureGroup--\",[28,[37,7],[[28,[37,8],[[28,[37,9],[[30,4,[\"title\"]]],null]],null]],null]]]],[12],[1,\"\\n            \"],[10,\"li\"],[14,0,\"tCH--featureList__li\"],[12],[1,\"\\n              \"],[10,0],[14,0,\"tCH--featureList__text\"],[12],[1,[30,4,[\"title\"]]],[13],[1,\"\\n            \"],[13],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,4,[\"features\"]]],null]],null],null,[[[1,\"              \"],[8,[39,10],null,[[\"@forCheckout\",\"@title\",\"@type\",\"@value\"],[\"true\",[30,5,[\"name\"]],[30,5,[\"type\"]],[30,5,[\"value\"]]]],null],[1,\"\\n\"]],[5]],null],[1,\"          \"],[13],[1,\"\\n\"]],[4]],null]],[]]],[1,\"    \"]],[]]]]],[1,\"\\n\\n    \"],[8,[30,3,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,11],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,1],[28,[37,2],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[3]]]]]],[\"@close\",\"@focusTrap\",\"modal\",\"group\",\"feature\"],false,[\"shared/modal\",\"did-insert\",\"t\",\"if\",\"shared/loading-spinner\",\"each\",\"-track-array\",\"css-safe\",\"camelize\",\"lowercase\",\"shared/upgrade/feature\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/upgrade/all-features-modal.hbs",
    "isStrictMode": false
  });
  let AllFeaturesModalComponent = _exports.default = (_class = class AllFeaturesModalComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "plans", _descriptor, this);
      _initializerDefineProperty(this, "segment", _descriptor2, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
      _initializerDefineProperty(this, "allFeaturesModalVisible", _descriptor4, this);
      _defineProperty(this, "getAllSubscriptionPlans", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.subscriptions.getAllSubscriptionPlans();
        }
      }), null, "getAllSubscriptionPlans", null));
      if (!this.subscriptions.subscriptionPlans.some(plan => plan.planType === this.args.planType)) {
        this.getAllSubscriptionPlans.perform();
      }
    }
    get groups() {
      return this.plans.featureGroups.map(featureGroup => Object.assign({}, featureGroup, {
        features: featureGroup.features.filter(feature => feature.name !== 'Twitter/X Analytics').map(feature => Object.assign({}, feature, {
          value: this.plan?.[feature.key]
        }))
      }));
    }
    get isLoading() {
      return this.getAllSubscriptionPlans.isRunning;
    }
    get plan() {
      return this.args.plan || this.plans.getPlan(this.planType, this.args.isMonthly);
    }
    get planName() {
      return this.plan?.name;
    }

    /**
     * Allows for @planType (preferred) or @plan to be passed in as an arg.
     */
    get planType() {
      return this.args.planType || this.args.plan?.planType;
    }
    trackAllFeaturesShown() {
      this.segment.track('viewed-page', {
        page: 'cart_see_all_plans'
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "plans", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "allFeaturesModalVisible", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "trackAllFeaturesShown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackAllFeaturesShown"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AllFeaturesModalComponent);
});